<template>
  <div id="newstrend-detail-page">
    <transition name="block">
      <div class="px-2" style="margin-top: 15px;">
        <div class="card card-default shade">
          <div class="card-body pt-2">
            <div class="d-flex align-items-center">
              <h3 style="font-size: 20px">
                <i class="bi bi-info-circle"></i> Detail News Trend
              </h3>
              <router-link
                id="back-newstrend"
                to="/newstrend"
                class="btn btn-success ml-auto mr-2"
              >
                <i
                  class="bi bi-chevron-double-left mr-1"
                  style="font-size: 10px"
                ></i>
                Kembali
              </router-link>
              <button
                id="edit-newstrend-detail"
                class="btn btn-complete m-r-5 edit"
                @click="editNewTrend()"
              >
                <i class="bi bi-pencil-square mr-2"></i> Edit News Trend
              </button>
            </div>
            <div>
              <h6>Judul</h6>
              <p id="title-newstrend">{{ judul }}</p>
            </div>
            <div class="mt-4">
              <h6>Deskripsi</h6>
              <p id="deskripsi-newstrend">
                {{ description != "" ? description : "-" }}
              </p>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8 component-header component-header-left">
                    <h6>Daftar Trend Berita</h6>
                  </div>
                  <div
                    class="col-md-4 component-header component-header-right"
                    style="display: none"
                  >
                    <button
                      aria-label=""
                      v-on:click="addTrend"
                      class="btn btn-success btn-icon-left"
                      type="button"
                    >
                      <i class="bi bi-plus"></i>
                      <span class="">Tambah Trend</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <table class="table table-bordered" id="trendtable">
                  <thead>
                    <tr>
                      <th class="text-center">Tanggal</th>
                      <th class="text-center">Jumlah Berita</th>
                      <th class="text-center">Streams</th>
                      <th class="text-center">Query</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
      :modal_size="modal_size"
    />
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import swal from "sweetalert";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_trend from "@/views/components/news-trend/modal_add_trend.vue";
import modal_add_query from "@/views/components/news-trend/modal_add_query.vue";
import modal_add_stream from "@/views/components/news-trend/modal_add_stream.vue";
import modal_edit_trend from "@/views/components/news-trend/modal_edit_trend.vue";
import modal_edit_news_trend from "@/views/components/news-trend/modal_edit_news_trend.vue";
import modal_view_stream from "@/views/components/news-trend/modal_view_stream.vue";

var modals = {
  title: "Tambah Trend",
  subtitle: "Silahkan masukan trend  yang akan ditambahkan",
  component: modal_add_trend,
};
var editModals = {
  title: "Edit News Trend",
  subtitle: "Silahkan untuk mengubah news trend yang akan diedit",
  component: modal_edit_news_trend,
};

export default {
  name: "NewsTrendDetail",
  title: "News Trend | Online Media Monitoring",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      id_news_trend: this.$route.query.q,
      is_loading: false,
      dataNewsTrend: {},
      judul: "",
      description: "",
      modal_key: 0,
      modal_data: [],
      currentModal: null,
      modal_size: "",
      tour_steps: [],
    };
  },
  methods: {
    addTrend: function () {
      this.modal_key++;
      this.currentModal = modals;
    },
    editTrend: function (idTrend, count) {
      var modal_edit = {
        title: "Edit Trend",
        subtitle: "edit trend",
        component: modal_edit_trend,
      };
      let dataTrend = [
        {
          idTrend: idTrend,
          count: count,
        },
      ];
      this.currentModal = modal_edit;
      this.modal_data = dataTrend;
      this.modal_key++;
    },
    editNewTrend: function () {
      this.modal_key++;
      this.currentModal = editModals;
      this.modal_data = this.id_news_trend;
    },
    deleteTrend: function (id, index) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus trend tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "/newstrend/delete-trend";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.table
                  .row("#" + index)
                  .remove()
                  .draw(false);
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Trend berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus trend.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    viewStream: function (idTrend, date) {
      var view_stream = {
        title: "News Trend",
        subtitle: "news trend pada tanggal " + date,
        component: modal_view_stream,
      };
      let dataTrend = [
        {
          idTrend: idTrend,
        },
      ];
      this.currentModal = view_stream;
      this.modal_data = dataTrend;
      this.modal_key++;
    },
    addQuery: function (idTrend, query) {
      var modals_query = {
        title: "Set Query News Trend",
        subtitle: "Query news trend",
        component: modal_add_query,
      };
      let dataTrend = [
        {
          idTrend: idTrend,
          query: query,
        },
      ];
      this.currentModal = modals_query;
      this.modal_data = dataTrend;
      this.modal_key++;
    },
    addStream: function (idTrend, date, streams) {
      var modal_streams = {
        title: "Tambah Berita",
        subtitle: "",
        component: modal_add_stream,
      };
      let dataTrend = [
        {
          idTrend: idTrend,
          from: moment(date).format("YYYY-MM-DD 00:00:00"),
          to: moment(date).format("YYYY-MM-DD 23:59:59"),
          streams: streams,
        },
      ];
      this.currentModal = modal_streams;
      this.modal_data = dataTrend;
      this.modal_key++;
    },
    getData: function () {
      this.is_loading = true;
      let api =
        process.env.VUE_APP_API_URL + "newstrend/detail/" + this.id_news_trend;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 204) {
            this.dataNewsTrend = {};
            this.is_loading = false;
          } else {
            this.table.clear();
            this.dataNewsTrend = response.data.trend;
            this.judul = response.data.title;
            this.description = response.data.description;
            this.is_loading = false;
            let btn, btnStream, btnQuery;

            for (let index in this.dataNewsTrend) {
              var dateString = moment
                .utc(this.dataNewsTrend[index].date)
                .tz("Asia/Jakarta")
                .locale("id")
                .format("YYYY-MM-DD HH:mm:ss");
              let tanggal = `<center>${dateString}</center>`;
              let count = `<center>${this.dataNewsTrend[index].count}</center>`;
              btnStream =
                '<center><button id="add-berita" class="btn btn-sm btn-complete m-r-5 addStream">Tambah Berita</button></center>';
              btnQuery =
                '<center><button id="use-query" class="btn btn-sm btn-complete m-r-5 addQuery">Gunakan Query</button></center>';
              btn =
                '<center><button id="detail-berita" class="btn btn-sm btn-success m-r-5 view"><i class="bi bi-eye"></i></button><button id="edit-berita" class="btn btn-sm btn-complete m-r-5 edit"><i class="bi bi-pencil-square"></i></button><button id="hapus-berita" class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
              this.table.row
                .add([tanggal, count, btnStream, btnQuery, btn])
                .node().id = index;
              this.table.column("0:visible").order("desc").draw();
            }
          }
        })
        .catch((err) => {
          this.resp = err.response;
          this.isError = true;
        });
    },
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    let self = this;
    this.table = $("#trendtable").DataTable();
    $("#trendtable tbody").on("click", ".addQuery", function () {
      self.modal_size = "";
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let idTrend = self.dataNewsTrend[id]._id.$oid;
      let query = self.dataNewsTrend[id].query;
      self.addQuery(idTrend, query);
    });
    $("#trendtable tbody").on("click", ".edit", function () {
      self.modal_size = "";
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let idTrend = self.dataNewsTrend[id]._id.$oid;
      let count = self.dataNewsTrend[id].count;
      self.editTrend(idTrend, count);
    });
    $("#trendtable tbody").on("click", ".del", function () {
      self.modal_size = "";
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let idTrend = self.dataNewsTrend[id]._id.$oid;
      self.deleteTrend(idTrend, id);
    });

    $("#trendtable tbody").on("click", ".view", function () {
      self.modal_size = "modal-lg";
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let idTrend = self.dataNewsTrend[id]._id.$oid;
      let date = self.dataNewsTrend[id].date;
      self.viewStream(idTrend, date);
    });

    $("#trendtable tbody").on("click", ".addStream", function () {
      self.modal_size = "modal-lg";
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      let idTrend = self.dataNewsTrend[id]._id.$oid;
      let streams = self.dataNewsTrend[id].streams;
      let date = self.dataNewsTrend[id].date;
      if ("page" in self.$route.query) {
        self.$route.query.page = "1";
      }
      self.addStream(idTrend, date, streams);
    });
    let v_step = [];
    v_step[0] = {
      target: "#edit-newstrend-detail",
      header: {
        title: "Edit Newstrend",
      },
      content: "Klik untuk mengedit Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#back-newstrend",
      header: {
        title: "Kembali",
      },
      content: "Klik untuk kembali ke halaman Newstrend",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#title-newstrend",
      header: {
        title: "Judul Newstrend",
      },
      content: "Menampilkan Judul dari Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#deskripsi-newstrend",
      header: {
        title: "Deskripsi Newstrend",
      },
      content: "Menampilkan Deskripsi dari Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#trendtable_filter",
      header: {
        title: "Cari Tren Berita",
      },
      content: "Masukkan kata kunci untuk mencari trend berita yang diinginkan",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#trendtable",
      header: {
        title: "Tabel Tren Berita",
      },
      content: "Menampilkan daftar trend berita dari Newstrend yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#add-berita",
      header: {
        title: "Tambah Berita",
      },
      content: "Klik untuk menambahkan berita",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#use-query",
      header: {
        title: "Gunakan Query",
      },
      content: "Klik untuk menggunakan query",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#detail-berita",
      header: {
        title: "Detail Berita",
      },
      content: "Klik untuk melihat detail berita yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#edit-berita",
      header: {
        title: "Edit Berita",
      },
      content: "Klik untuk mengedit berita yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#hapus-berita",
      header: {
        title: "Hapus Berita",
      },
      content: "Klik untuk menghapus berita yang dipilih",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>